import React, { useEffect, useState, useRef  } from 'react'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import HoursManagement from './HoursManagement'
import KeywordsManagement from './KeywordsManagement'
import DeleteConfirmDialog from './DeleteConfirmDialog';
import InfoBanner from '../common/InfoBanner'

import {US_TIMEZONES} from 'utils/timezones'
import {utc_timestamp_to_local_datetime_string, utc_timestamp_to_hours_ago_string} from "../../utils/datetime_utc_local";
import {ecosackState} from "../../utils/ecosackState";

// @material-ui/core components
import { Typography, Modal, Button, Box, Grid } from '@material-ui/core'
import _, { get } from 'lodash'

import EditIcon from '@material-ui/icons/Edit';

import LedgerComponent from './LedgerComponent'

const evt = new Event('customertable_is_dirty');

const useStyles = makeStyles((theme) => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: theme.palette.background.default,
    border: '2px solid #000',
    boxShadow: 24,
    padding: 4,
    maxHeight: '100vh', 
    overflowY: 'auto' 
  },
  fieldLabel: {
    display: 'block',
    width: '150px',
  },
  formGroup: {
    float: 'left',
    margin: '10px',
  },
  booleanField: {
    width: '256px'
  },
  formControl: {
    display: 'block',
    width: '256px',
  },
  detailsStatus: {
    lineHeight: '36px',
    padding: '10px'
  },
  errorMessage: { 
    color: 'red'
  },
  submitButton: {
    margin: '10px',
    display: 'block',
    float: 'left'
  },
  editButton: {
    padding: '8px'
  },
  deleteButton: {
    backgroundColor: "#ff0000",
    margin: '10px',
    display: 'block',
    float: 'left'
  },
  checkBoxContainer: {
    display: 'inlineBlock',
    verticalAlign: 'middle',
    lineHeight: '38px'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    marginRight: '10px',
    verticalAlign: 'middle'
  },
  breakFloat: {
    clear: 'both'
  },
  statsText: {
    fontSize: '24px',
    fontWeight: 'bold'
  },
  statsTextLarge: {
    fontSize: '40px',
    fontWeight: 'bold'
  },
  fullWidth: {
    width: '100%'
  },
  hoursContainer: {
    float: 'left',
  },
  baseSixtyFourImage: {
    width: '260px'
  },
  progress:{
    width: '50%', 
    marginLeft: 'auto', 
    marginRight: 'auto'
  },
  textAlignRight: { textAlign: 'right' },
  textAlignCenter: { textAlign: 'center' },
}))


export const DetailsEditComponent = (props) => {
  const [details, setDetails] = useState({})
  const [operationtypes, setOperationtypes] = useState([])
  const [intervals, setIntervals] = useState([])
  const [devicetypes, setDevicetypes] = useState([])
  const [tenants, setTenants] = useState([])
  const [tenantsites, setTenantsites] = useState([])
  const [materials, setMaterials] = useState([])
  const [status, setStatus] = useState({
    kind: "idle",          // "idle" | "info" | "loading" | "success" | "error"
    message: "",
    dirty: { main: false, hours: false }
  });
  const [deleteStatus, setDeleteStatus] = useState({
    kind: "idle",          // "idle" | "loading" | "success" | "error"
    message: ""
  });
  const [tzidValue, setTzidValue] = useState("");
  const [twoFactorChannelValue, setTwoFactorChannelValue] = useState("");
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const auth = useSelector(state => state.auth)

  const hoursRef = useRef();
  const keywordsRef = useRef();
  const classes = useStyles()

  const {
    rowData,
    detail_get_url,
    detail_put_url,
    detail_delete_url,
    detail_delete_method,
    ledger_get_url,
    ledger_insert_url,
    ledger_allow_entries,
    show_machine_stats,
    showHeader,
    info_banner_items,
    editable_fields = [],
    non_editable_fields = [],
  } = props;

  useEffect(() => {
    const fetchDetails = async () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      const results = await axios.get(detail_get_url + encodeURIComponent(rowData.id), config)

      setDetails(results.data)
    }

  // get enum-values for select-field if needed
  const fetchDevicetypes = async () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/machines/devicetypes`, config)
    setDevicetypes(results.data)
  };

  const fetchOperationtypes = async () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/machines/operationtypes`, config)
    setOperationtypes(results.data)
  };

  const fetchIntervals = async () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/invoicing/intervals`, config)
    setIntervals(results.data)
  };

  const fetchTenants = async () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/tenants`, config)
    setTenants(results.data)
  }

  const fetchTenantSites = async () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/tenant_sites`, config)
    setTenantsites(results.data)
  }

    // get enum-values for materials
      const fetchMaterialtypes = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/materials`, config)
        setMaterials(results.data)
      };

    fetchMaterialtypes();
    fetchDetails();
    fetchDevicetypes();
    fetchOperationtypes();
    fetchIntervals();
    fetchTenantSites();
    fetchTenants();
  }, [rowData])

  useEffect(() => {
    if (details?.tzid) setTzidValue(details.tzid);
  }, [details?.tzid]);

  useEffect(() => {
    if (details?.two_factor_preferred_channel) setTwoFactorChannelValue(details.two_factor_preferred_channel);
  }, [details?.two_factor_preferred_channel]);

  // submit data and update object
  const handleSubmit = async (event) => {
    event.preventDefault();

    const config = { headers: { 'Content-Type': 'application/json' } };
    if (auth && auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`;
    }

    const dirtyMain  = status?.dirty?.main && editable_fields.length > 0;
    const dirtyHours = status?.dirty?.hours && !!hoursRef.current;
    const dirtyKeywords = status?.dirty?.keywords && !!keywordsRef.current;

    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    // keep your flexible ID source, but otherwise behave like function 1
    const targetId = (details?.id ?? rowData?.id ?? '').toString();

    let updatePromises = [];
    let updateMessages = [];

    // show loading (preserve any existing dirty flags on status if you already added them)
    setStatus((s) => ({ ...s, kind: "loading", message: "Saving..." }));

    // Handle main form submission if there are changes
    if ((dirtyMain || dirtyKeywords) && Array.isArray(editable_fields) && editable_fields.length > 0) {
      const data = new FormData(event.target);
      const value = Object.fromEntries(data.entries());

      // do some postprocessing for values if needed (match function 1 style)
      editable_fields.map(function (fieldname /* [name, label, type] */) {
        switch (fieldname[2]) {
          case 'currency':
            value[fieldname[0]] = value[fieldname[0]] * 1e6; // dollar to microdollar
            break;
        }
      });

      if (value.new_state !== undefined) {
        value.new_state = Number(value.new_state);
      }
      
      // Turn empty fields into nulls
      const cleaned = Object.fromEntries(
        Object.entries(value).map(([key, val]) => [
          key,
          val === "" ? null : val
        ])
      );

      if (dirtyKeywords && keywordsRef.current) {
        cleaned.keyword_ids = keywordsRef.current.getKeywordIds();
      }

      updatePromises.push(
        axios
          .put(detail_put_url + targetId, cleaned, config)
          .then(() => updateMessages.push('Site details updated'))
          .catch((error) => {
            if (error.response?.data?.msg) {
              updateMessages.push(`${error.response.data.msg}`);
            } else {
              updateMessages.push('Error updating site details');
            }
            throw error;
          })
      );
    }

    // Handle hours submission if there are changes
    if (dirtyHours && hoursRef?.current) {
      const hoursData = hoursRef.current.getHoursData();

      // Always POST all hours data (including services closed all week)
      updatePromises.push(
        axios
          .post(`${detail_put_url + targetId}/hours`, hoursData, config)
          .then(() => updateMessages.push('Hours updated'))
          .catch((error) => {
            if (error.response?.data?.message) {
              updateMessages.push(`Error updating hours: ${error.response.data.msg}`);
            } else {
              updateMessages.push('Error updating hours');
            }
            throw error;
          })
      );
    }

		// Execute all updates
    if (updatePromises.length > 0) {
      // NOTE: use allSettled so one failure doesn't cancel the rest
      Promise.allSettled(updatePromises)
        .then((results) => {
          const anyRejected = results.some((r) => r.status === "rejected");
          const finalMessage =
            updateMessages.join(", ") ||
            (anyRejected ? "Error updating some fields" : "Saved");

          // Reset change flags (unchanged behavior)
          if (hoursRef.current && typeof hoursRef.current.resetChanges === "function") {
            hoursRef.current.resetChanges();
          }
          if (keywordsRef.current && typeof keywordsRef.current.resetChanges === "function") {   // add
            keywordsRef.current.resetChanges();
          }

          // Unified status
          setStatus((s) => ({
            ...s,
            kind: anyRejected ? "error" : "success",
            message: finalMessage,
            // if you later add status.dirty, clear it safely
            dirty: s?.dirty ? { main: false, hours: false, keywords: false } : s?.dirty
          }));

          if (!anyRejected) {
            window.dispatchEvent(evt);
          }
        })
        .catch(() => {
          setStatus((s) => ({ ...s, kind: "error", message: "Error updating some fields" }));
        });
    } else {
      setStatus((s) => ({ ...s, kind: "info", message: "No changes to save" }));
    }
  };

  const handle_delete = async (ledger_id) => {
    const config = { headers: { 'Content-Type': 'application/json' } }
    setDeleteStatus({kind: "loading", message: "Deleting..."});

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    // most list/edit tables delete via a GET route (legacy backend convention);
    // pass detail_delete_method="delete" for endpoints using a real HTTP DELETE verb
    const method = (detail_delete_method || 'get').toLowerCase();

    await axios[method](detail_delete_url + rowData.id, config)
      .then((response) => {
        window.dispatchEvent(evt);
        setDeleteStatus({kind: "success", message: "Deleted successfully"});
      })
      .catch(function (error) {
        window.dispatchEvent(evt);
        setDeleteStatus({kind: "error", message: error.response.data.message});
    });
  }
  

  // Handler for main form field changes
  const handleMainFormChange = (e) => {
    // update local state so controlled inputs can change
    if (e?.target) {
      const { name, type, checked, value } = e.target;
      setDetails((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }

    setStatus(s => ({
      ...s,
      kind: "info",
      message: "Unsaved changes",
      dirty: { ...s.dirty, main: true }
    }));
  };

  const handleDeleteConfirm = async () => {
    setDeleteStatus({ kind: "loading", message: "Deleting..." });

    try {
      const config = { headers: { 'Content-Type': 'application/json' } };
      if (auth?.access_token) config.headers.Authorization = `Bearer ${auth.access_token}`;

      const targetId = details?.id ?? rowData?.id;

      await axios.delete(
        `${detail_put_url}${encodeURIComponent(targetId)}`,
        config
      );

      setDeleteStatus({
        kind: "success",
        message: "Deleted successfully",
      });

      window.dispatchEvent(evt);
      setShowDeleteWarning(false);
    } catch (err) {
      setDeleteStatus({
        kind: "error",
        message:
          err.response?.data?.msg ||
          err.response?.data?.message ||
          err.message,
      });
    }
  };

  // Handler for hours changes
  const handleHoursChange = (hasChanges) => {
    setStatus(s => ({
      ...s,
      kind: hasChanges ? "info" : s.kind,
      message: hasChanges ? "Unsaved changes" : s.message,
      dirty: { ...s.dirty, hours: hasChanges }
    }));
  };

  const handleDeleteServiceHours = async (serviceKey) => {

    const config = { headers: { 'Content-Type': 'application/json' } };
    if (auth?.access_token) config.headers.Authorization = `Bearer ${auth.access_token}`;

    const targetId = (details?.id ?? rowData?.id ?? '').toString();
    if (!targetId) {
      setStatus((s) => ({
        ...s,
        kind: "error",
        message: 'Missing ID',
      }));
      return;
    }

    try {
      await axios.delete(
        `${detail_put_url}${encodeURIComponent(targetId)}/hours/${encodeURIComponent(serviceKey)}`,
        config
      );

      setDetails(prev => {
        // remove from active_services (array of strings or {id,...})
        const nextActive = (prev?.active_services || []).filter(s =>
          typeof s === 'string' ? s !== serviceKey : s?.id !== serviceKey
        );
        // drop the deleted key from hours
        const prevHours = prev?.hours || {};
        const { [serviceKey]: _removed, ...restHours } = prevHours;
        return {
          ...prev,
          active_services: nextActive,
          hours: restHours,
        };
      });

      setStatus((s) => ({
        ...s,
        kind: "success",
        message: `Deactivated ${serviceKey} service`,
      }));
      window.dispatchEvent(evt);
    } catch (e) {
      setStatus((s) => ({
        ...s,
        kind: "error",
        message: `Error deactivating ${serviceKey} service`,
      }));
    }
  };

  const handleKeywordsChange = (hasChanges) => {
    setStatus(s => ({
      ...s,
      kind: hasChanges ? "info" : s.kind,
      message: hasChanges ? "Unsaved changes" : s.message,
      dirty: { ...s.dirty, keywords: hasChanges }
    }));
  };

  return (
    <>
      {info_banner_items && info_banner_items.length > 0 &&
        <InfoBanner items={info_banner_items} style={{marginTop: '0', marginBottom: '20px' }}/>
      }
      {showHeader && <>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Details {rowData.id}
        </Typography>

        <hr />
      </>
      }

      {
        non_editable_fields.map(function(fieldname, bla){
          const detailValue = get(details, fieldname[0]);
            switch (fieldname[2]) {
              case "date":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} />
                </div>
              case "boolean":
                return <div className={`form-group ${classes.formGroup}`}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <input disabled type="checkbox" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} />
                </div>
              case "currency":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue !== undefined && detailValue !== null ? "$" + (detailValue/ 1e6).toFixed(2) : ""}  />
                </div>
              case "timestamp":
				        return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue ? utc_timestamp_to_local_datetime_string(detailValue) : ''} />
                </div>
              case "weight":
              case "count":
                if(detailValue !== undefined && detailValue != 0){
                    return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue}  />
                    </div>
                }
                break
              case "dont_show_if_empty":
                if(detailValue !== undefined){
                    return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue}  />
                    </div>
                }
                break
              case "changelist":
                if(detailValue === undefined){
                    return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value="No changes"  />
                    </div>
                }else if(detailValue.length === 0 ){
                    return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value="No changes"  />
                    </div>
                }else{
                    return <div className={`form-group ${classes.formGroup} ${classes.fullWidth}`}>Changelist:<br/>
                        <table>
                        <tr><th>Type</th><th>Subject</th><th>Old val</th><th>&nbsp;</th><th>New val</th></tr>
                        {detailValue.map(function(change, bla){
                        if(change.new_value_count !== null){
                            if(change.old_value_count === null){
                                return <tr><td>[C]</td><td>{change.subject}</td><td></td><td>-{'>'}</td><td>{change.new_value_count}</td></tr>
                            }else{
                                return <tr><td>[C]</td><td>{change.subject}</td><td>{change.old_value_count}</td><td>-{'>'}</td><td>{change.new_value_count}</td></tr>
                            }

                        }else{
                            if(change.old_value_weight_lbs === null){
                                return <tr><td>[W]</td><td>{change.subject}</td><td></td><td>-{'>'}</td><td>{change.new_value_weight_lbs}lbs</td></tr>
                            }else{
                                return <tr><td>[W]</td><td>{change.subject}</td><td>{change.old_value_weight_lbs}lbs</td><td>-{'>'}</td><td>{change.new_value_weight_lbs}lbs</td></tr>
                            }

                        }
                        })}
                        </table></div>
                }
              case "subaccountlist":
                if(detailValue === undefined || detailValue.length === 0){
                    return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value="None"  />
                    </div>
                }else{
                    return <div className={`form-group ${classes.formGroup} ${classes.fullWidth}`}>{fieldname[1]}:<br/>
                        <table>
                        <tr><th>Business Name</th><th>Email</th></tr>
                        {detailValue.map(function(sa, bla){
                            return <tr><td>{sa.business_name}</td><td>{sa.email}</td></tr>
                        })}
                        </table></div>
                }
              case "b64image":
                if(detailValue !== undefined){
                  return <div className={`form-group ${classes.formGroup}`}>
                    <img className={`form-control ${classes.baseSixtyFourImage}`} src={`data:image/jpeg;base64,${detailValue}`} />
                    </div>
                }
                break
              case "ecosackState":
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={ecosackState(detailValue)}  />
                    </div>
              case "hours_ago":
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={utc_timestamp_to_hours_ago_string(detailValue)}  />
                    </div>
              case "break":
                  return (
                  <>
                    <hr className={classes.breakFloat} />
                    {fieldname[1] && <Typography variant="h6">{fieldname[1]}</Typography>}
                  </>
                )
              case "header":
                  return <Typography variant="h6">{fieldname[1]}</Typography>
              default:
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue}  />
                </div>
            }
        })
      }

      <form key={details?.id ?? 'loading'} onSubmit={handleSubmit}>
        {
          editable_fields.map(function (fieldname, bla) {
            const detailValue = get(details, fieldname[0]);
            switch (fieldname[2]) {
              case "date":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange} />
                </div>
              case "material":
                  return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                        {_.map(materials, opt => { return (
                          (opt == detailValue) ? (<option selected key={opt} value={opt}>{opt}</option>) : (<option key={opt}value={opt}>{opt}</option>)
                          )
                          })}
                      </select>
                    </div>
              case "devicetype":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(devicetypes, opt => { return (
                      (opt.name == detailValue) ? (<option selected key={opt.id} value={opt.name}>{opt.name}</option>) : (<option key={opt.id} value={opt.name}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "operationtype":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(operationtypes, opt => { return (
                      (opt.id == detailValue) ? (<option selected key={opt.id} value={opt.id}>{opt.name}</option>) : (<option key={opt.id} value={opt.id}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "interval_name":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(intervals, opt => { return (
                      (opt.name == detailValue) ? (<option selected key={opt.id} value={opt.name}>{opt.name}</option>) : (<option key={opt.id} value={opt.name}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "tenantsite":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(tenantsites, opt => { return (
                      (opt.id == detailValue) ? (<option selected key={opt.id} value={opt.id}>{opt.name}</option>) : (<option key={opt.id} value={opt.id}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "tenant":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(tenants, opt => { return (
                      (opt.id == detailValue) ? (<option selected key={opt.id} value={opt.id}>{opt.business_name}</option>) : (<option key={opt.id} value={opt.id}>{opt.business_name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "tenant_optional":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue || ""} onChange={handleMainFormChange}>
                    <option value="">None</option>
                    {_.map(tenants, opt => { return (
                      (opt.id == detailValue) ? (<option selected key={opt.id} value={opt.id}>{opt.business_name}</option>) : (<option key={opt.id} value={opt.id}>{opt.business_name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "boolean":
                return <div className={`form-group ${classes.formGroup} ${classes.booleanField}`}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <input type="hidden" name={fieldname[0]} value={false} />
                    <div className={classes.checkBoxContainer}>
                        <input type="checkbox" className={`custom-control-input ${classes.checkbox}`} name={fieldname[0]} id={fieldname[0]} value={true} checked={!!detailValue} onChange={handleMainFormChange} />{fieldname[1]}
                    </div>
                </div>
              case "b64image": {
                const handleImageUpload = (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const reader = new FileReader();
                  reader.onload = (ev) => {
                    const base64 = ev.target.result.split(',')[1];
                    handleMainFormChange({ target: { name: fieldname[0], type: 'text', value: base64 } });
                  };
                  reader.readAsDataURL(file);
                };
                return (
                  <div className={`form-group ${classes.formGroup}`}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    {detailValue && (
                      <img className={`form-control ${classes.baseSixtyFourImage}`} src={`data:image/jpeg;base64,${detailValue}`} alt={fieldname[1]} />
                    )}
                    <input type="file" accept="image/*" onChange={handleImageUpload} />
                    <input type="hidden" name={fieldname[0]} value={detailValue || ''} />
                  </div>
                );
              }
              case 'hours':
                  return (
                      <div className={`${classes.hoursContainer} ${classes.fullWidth}`}>
                          {details.hours && (
                              <HoursManagement
                                  ref={hoursRef}
                                  initialHoursData={details.hours}
                                  activeServices={details.active_services}
                                  availableServices={details.available_services}
                                  onHoursChange={handleHoursChange}
                                  onDeleteService={handleDeleteServiceHours}
                              />
                          )}
                          <br className={classes.breakFloat} />
                      </div>
                  );
                case "tzid":
                  return (
                    <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>
                        {fieldname[1]}
                      </label>
                      <select
                        className={`form-control ${classes.formControl}`}
                        name={fieldname[0]}
                        id={fieldname[0]}
                        value={tzidValue}
                        onChange={(e) => {
                          setTzidValue(e.target.value);
                          handleMainFormChange();
                        }}
                      >
                        <option value="" disabled>Select timezone</option>
                        {US_TIMEZONES.map((tz) => (
                          <option key={tz.value} value={tz.value}>
                            {tz.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                case 'new_state':
                  return (
                  <div className="form-group" style={{ float: 'left', margin: '10px' }}>
                    <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                    <select
                      className="form-control"
                      style={{ width: '256px' }}
                      name={fieldname[0]}
                      id={fieldname[0]}
                      value={details?.new_state ?? details?.state ?? detailValue ?? ""}
                      onChange={handleMainFormChange}
                    >
                      <option value="" disabled >Select action</option>
                      {/* Should we allow tenants to set ecosack back to free? */}
                      <option value={1}>With Customer</option>
                      <option value={2}>Dropped Off</option>
                      <option value={3}>Processed</option>
                    </select>
                  {(details.state === 1 ||
                    details.new_state === 1 ||
                    String(details.new_state) === "1") && (
                    <input
                      type="hidden"
                      name="customer_id"
                      value={details.customer_id ?? ""}
                    />
                  )}
                  </div>
                  );
                case "id_receiving_tenant": {
                  const state = String(details.new_state ?? details.state ?? '');
                  const isEnabled = state === '2' || state === '3';
                  return (
                    <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>
                        {fieldname[1]}
                      </label>
                      <select
                        className={`form-control ${classes.formControl}`}
                        name={fieldname[0]}
                        id={fieldname[0]}
                        value={details?.name_receiving_tenant ?? detailValue ?? ""}
                        onChange={handleMainFormChange}
                        disabled={!isEnabled}
                      >
                        <option value="" disabled>Select tenant</option>
                        {_.map(tenants, (opt) =>
                          <option key={opt.id} value={opt.id}>
                            {opt.business_name}
                          </option>
                        )}
                      </select>
                    </div>
                  );
                }
                case 'keywords':
                  return (
                    <div className={`${classes.hoursContainer} ${classes.fullWidth}`}>
                      <KeywordsManagement
                        ref={keywordsRef}
                        title="Keywords"
                        initialItems={details.keywords}
                        itemLabel="keyword"
                        listUrl={`${ServerConfig.SERVER_URL}/admin/support/keywords`}
                        createUrl={`${ServerConfig.SERVER_URL}/admin/support/keywords`}
                        createBody={(term) => ({ keyword: term })}
                        onItemsChange={(dirty) =>
                          setStatus(s => ({ ...s, dirty: { ...s.dirty, keywords: dirty } }))
                        }
                      />
                    </div>
                    
                  )
                case 'synonyms':
                  return (
                    <div className={`${classes.hoursContainer} ${classes.fullWidth}`}>
                      <KeywordsManagement
                        title="Synonyms"
                        initialItems={details.synonyms}
                        itemLabel="synonym"
                        addOnly={true}
                        createUrl={`${ServerConfig.SERVER_URL}/admin/support/keywords/${details.id}/synonyms`}
                        createBody={(term) => ({ synonym: term })}
                        deleteUrl={`${ServerConfig.SERVER_URL}/admin/support/synonyms`}
                      />
                    </div>

                  )
                case 'textarea':
                  const textareaRows = fieldname[3] || 6;  // default 6 if not specified
                  return <div className={`form-group ${classes.formGroup} `}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <textarea
                      className="form-control"
                      name={fieldname[0]}
                      id={fieldname[0]}
                      rows={textareaRows}
                      defaultValue={detailValue}
                      onChange={handleMainFormChange}
                      style={{ width: '100%', fontFamily: 'inherit' }}
                    />
                  </div>
                case 'delete':
                  return (
                    <div className={`${classes.hoursContainer} ${classes.fullWidth}`}>
                      <br className={classes.breakFloat} />
                      <DeleteConfirmDialog
                        title="Delete Entry"
                        message="You are about to permanently delete this entry. This action cannot be undone."
                        showWarning={showDeleteWarning}
                        isLoading={deleteStatus.kind === "loading"}
                        onTrigger={() => setShowDeleteWarning(true)}
                        onConfirm={handleDeleteConfirm}
                        onCancel={() => setShowDeleteWarning(false)}
                        triggerLabel="Delete Entry"
                        confirmLabel="Delete"
                      />
                      <Typography 
                        id="delete_status" 
                        variant="h6" 
                        component="h2" 
                        className={classes.detailsStatus}
                      >
                        {deleteStatus.kind === "error"? <span className={classes.errorMessage}>ERROR: {deleteStatus.message}</span> : deleteStatus.message}
                      </Typography>
                    </div>
                  )
                case 'supportquestionstatus':
                  return <div className={`form-group ${classes.formGroup}`}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <select
                      className={`form-control ${classes.formControl}`}
                      name={fieldname[0]}
                      id={fieldname[0]}
                      defaultValue={detailValue}
                      onChange={handleMainFormChange}
                    >
                      <option value="draft">Draft</option>
                      <option value="published">Published</option>
                      <option value="archived">Archived</option>
                    </select>
                  </div>
                case "two_factor_channel":
                  return (
                    <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>
                        {fieldname[1]}
                      </label>
                      <select
                        className={`form-control ${classes.formControl}`}
                        name={fieldname[0]}
                        id={fieldname[0]}
                        value={twoFactorChannelValue}
                        onChange={(e) => {
                          setTwoFactorChannelValue(e.target.value);
                          handleMainFormChange(e);
                        }}
                      >
                        <option value="" disabled>Select channel</option>
                        <option value="sms">SMS</option>
                        <option value="email">Email</option>
                      </select>
                    </div>
                  );
                case "tenant_site_id": {
                  const isReceiving = fieldname[0] === 'id_site_receiving';
                  const isProcessing = fieldname[0] === 'id_site_processing';
                  const state = String(details.new_state ?? details.state ?? '');

                  const isEnabled =
                    (isReceiving && (state === '2' || state === '3')) ||
                    (isProcessing && state === '3');

                  const sitesForTenant = tenantsites.filter(s => s.owner === details.id_tenant_receiving);

                  return <div className="form-group" style={{ float: 'left', margin: '10px' }}>
                    <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                    <select
                      className="form-control"
                      style={{ width: '256px' }}
                      name={fieldname[0]}
                      id={fieldname[0]}
                      value={detailValue ?? ''}
                      onChange={handleMainFormChange}
                      disabled={!isEnabled}
                    >
                      <option value="" disabled>Select site</option>
                      {_.map(sitesForTenant, opt => (
                        <option key={opt.id} value={opt.id}>{opt.name}</option>
                      ))}
                    </select>
                  </div>
                }
                case "info_banner":
                  return (
                    <InfoBanner
                      key="info_banner"
                      items={[
                        <>Select <b>"Dropped Off"</b> or <b>"Processed"</b> for State to enable the tenant and site fields.</>,
                        <>Select a <b>Receiving Tenant</b> to enable the site fields.</>,
                      ]}
                    />
                  );
              default:
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <input type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange} />
                </div>
            }

          })
        }
        {editable_fields.length > 0 &&
            <>
            <br className={classes.breakFloat} />
            <Button type='submit' className={classes.submitButton}>Save</Button>
            <Typography
              id="details_status"
              variant="h6"
              component="h2"
              className={classes.detailsStatus}
            >
              {status.kind === "error"? <span className={classes.errorMessage}>ERROR: {status.message}</span> : status.message}
            </Typography>
            </>
        }
      </form>

      {detail_delete_url !== undefined &&
            <>
            <br className={classes.breakFloat} />
            <Button onClick={() => handle_delete(rowData.id)} className={classes.deleteButton}>Delete</Button>
            <Typography id="delete_status" variant="h6" component="h2" className={classes.detailsStatus}>
              {deleteStatus.kind === "error"? <span className={classes.errorMessage}>ERROR: {deleteStatus.message}</span> : deleteStatus.message}
            </Typography>
            </>
        }

      {(ledger_get_url !== undefined) &&
        <LedgerComponent
            rowData={rowData}
            ledger_get_url={ledger_get_url}
            ledger_insert_url={ledger_insert_url}
            ledger_allow_entries={ledger_allow_entries}
            tenants={tenants}
        />
      }

      <hr className={classes.breakFloat} />

      {(show_machine_stats !== undefined) &&
        <>
          <Grid container>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">MLRS Version</Typography><br className={classes.breakFloat} />
                <span className={classes.statsText}>{details['mlrs_version']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={4}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Modelweights</Typography><br className={classes.breakFloat} />
                <span className={classes.statsText}>{(details['modelweights_path'] !== undefined && details['modelweights_path'] !== null) && details['modelweights_path'].split("/").slice(-2)[0]}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Currently online:</Typography><br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['online']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">#Containers counted:</Typography><br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['total_containers']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Runtime (s):</Typography> <br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['total_runtime_s']}</span>
              </Box>
            </Grid>
          </Grid>

          <hr />

          <Grid container>
            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Estop State</Typography><br className={classes.breakFloat} />
                <span className={classes.statsText}>{details['estop_state']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Currently online:</Typography><br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['estop_bypass']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Temperature:</Typography><br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['temperature']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={2}>
              <Box className={classes.textAlignCenter}>
                <Typography variant="body">Flapper RPM:</Typography><br className={classes.breakFloat} />
                <span className={classes.statsTextLarge}>{details['flapper_rpm']}</span>
              </Box>
            </Grid>
          </Grid>

          <hr />

          <Grid container>
            <Grid item sm={6} md={3}>
              <Box className={classes.textAlignCenter}>
                <Typography>CPU: {details['cpu_used_perc']}%</Typography>
                {/* <Progress progress={details['cpu_used_perc']} className={classes.progress} /> */}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box className={classes.textAlignCenter}>
                <Typography>RAM: {details['ram_used_perc']}%</Typography>
                {/*<Progress progress={details['ram_used_perc']} className={classes.progress} />*/}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box className={classes.textAlignCenter}>
                <Typography>HDD-1: {details['disk1_used_perc']}%</Typography>
                {/*<Progress progress={details['disk1_used_perc']} className={classes.progress} />*/}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box className={classes.textAlignCenter}>
                <Typography>HDD-2: {details['disk2_used_perc']}%</Typography>
                {/*<Progress progress={details['disk2_used_perc']} className={classes.progress} />*/}
              </Box>
            </Grid>
          </Grid>
        </>

      }
    </>
  );
}

// handles button and modal overlay
const EditComponent = (props) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles()
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <td className={classes.textAlignRight}>
      <Button onClick={handleOpen} className={classes.editButton}><EditIcon /></Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.detailsBox}>

          <DetailsEditComponent {...props} />
        </Box>
      </Modal>
    </td>
  );
};

export default EditComponent;